<template>
  <div>
    <div class="com-list-header" style="padding:30px 280px 30px 10px">
      <el-form :model="form" class="com-search-box" ref="form" label-width="90px">
        <el-row :gutter="20">
          <el-col :span="7">
            <el-form-item label="关键字 :" prop="key">
              <el-input v-model="form.key" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="7" v-if="pageType!=='3'">
            <el-form-item :label="typeObj[pageType]+' :'" prop="type">
              <el-select v-model="form.type" placeholder="请选择" clearable>
                <el-option v-for="item in typeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="7">
            <el-form-item label="时间 :" label-width="78px">
              <el-date-picker v-model="time" type="daterange" value-format="yyyy-MM-dd" start-placeholder="开始时间" end-placeholder="结束时间"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div class="com-head-search-btns">
        <el-button type="primary" @click="getTableList">查询</el-button>
        <el-button @click="restList('form')">重置</el-button>
        <el-button @click="cancel">返回</el-button>
      </div>

    </div>

    <div class="table mt-20">
      <!-- 加班 -->
      <el-table ref="multipleTable" stripe :data="tableData" v-if="pageType === '2'">
        <el-table-column prop="userName" label="姓名" min-width="7%" show-overflow-tooltip></el-table-column>
        <el-table-column prop="jbType" label="加班类型" min-width="10%"></el-table-column>
        <el-table-column prop="date" label="加班时间" min-width="20%"></el-table-column>
        <el-table-column prop="duration" label="加班时长" min-width="10%"></el-table-column>
        <el-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <a class="m-btn mr-10" @click="handleView(scope.row)">查看</a>
          </template>
        </el-table-column>
      </el-table>

      <!-- 请假 -->
      <el-table ref="multipleTable" stripe :data="tableData" v-if="pageType === '1'">
        <!-- <el-table-column type="selection" width="55">
        </el-table-column> -->
        <el-table-column prop="userName" label="姓名" min-width="7%" show-overflow-tooltip></el-table-column>
        <el-table-column prop="qjType" label="请假类别" min-width="10%"></el-table-column>
        <el-table-column prop="date" label="请假时间" min-width="10%"></el-table-column>
        <el-table-column prop="duration" label="请假时长" min-width="10%"></el-table-column>
        <el-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <a class="m-btn mr-10" @click="handleView(scope.row)">查看</a>
          </template>
        </el-table-column>
      </el-table>

      <!-- 串休 -->
      <el-table ref="multipleTable" stripe :data="tableData" v-if="pageType === '3'">
        <!-- <el-table-column type="selection" width="55">
        </el-table-column> -->
        <el-table-column prop="userName" label="姓名" min-width="7%" show-overflow-tooltip></el-table-column>
        <el-table-column prop="date" label="串休时间" min-width="10%"></el-table-column>
        <el-table-column prop="duration" label="串休时长" min-width="10%"></el-table-column>
        <el-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <a class="m-btn mr-10" @click="handleView(scope.row)">查看</a>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-container paging">
        <el-pagination :current-page="listQuery.currentPage" :page-size="listQuery.size" :total="total" background layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
      </div>
    </div>
    <approve-panel ref="approvePanel" :roleType="''" @refresh="initList"></approve-panel>
  </div>
</template>

<script>
import approvePanel from './dialog/approve-panel' // 审批面板
export default {
  components: {
    approvePanel
  },
  watch: {
    time(newVal) {
      this.form.startDate = ''
      this.form.endDate = ''
      if (newVal && newVal.length) {
        this.form.startDate = newVal[0]
        this.form.endDate = newVal[1]
      }
    }
  },
  data() {
    return {
      pageType: '', // 1 请假  2 加班  3 串休
      businessType: '', // 带入请假类型 1事假  2病假  或 带入加班类型 1节假日加班  2其他加班
      detailData: {},
      typeObj: {
        '2': '加班类型',
        '1': '请假类别'
      },
      form: {
        key: '',
        type: '',
        startDate: '',
        endDate: '',
      },
      total: 0,
      tableData: [],
      typeList: [],
      time: [], // 开始结时间
      dialogVisible: false,
      listQuery: {
        currentPage: 1,
        size: 10
      },
    }
  },
  mounted() {
    const { pageType, businessType, obj } = this.$route.query

    this.pageType = pageType // 1 请假 2 加班 3 串休
    this.businessType = businessType
    this.detailData =  JSON.parse(decodeURIComponent(obj))

    this.$set(this.form, 'type', '')

    this.getDropdownValue()

  },
  methods: {
    initList() {
      this.$http
        .get('/attendanceStat/listMonth', {
          ...this.listQuery,
          ...this.form,
          type: this.pageType,  // 1 请假 2 加班 3 串休
          year: this.detailData.year,
          userId: this.detailData.userId,
          jbType: this.pageType == '2' ? this.form.type : '',
          qjType: this.pageType == '1' ? this.form.type : ''
        })
        .then(res => {
          if (res.success) {
            this.tableData = res.result
            this.total = res.page.allRow

            console.log(this.tableData)
          } else {
            this.$message.error(res.message)
          }
        })
    },
    handleView(item) {
      this.$refs.approvePanel.init({ actvityId: item.activityId })
    },
    // 获取下拉状态选择值
    getDropdownValue() {
      this.$http
        .post('/attendanceStat/dict', {
        })
        .then(res => {
          if (res.success) {
            var state = res.result
            let firstArr = [{ id: null, name: '全部' }]
            if (this.pageType === '1') {
              this.typeList = firstArr.concat(state['qjType'])
            } else if (this.pageType === '2') {
              this.typeList = firstArr.concat(state['jbType'])
            }

            if (this.pageType == '1' && this.businessType) {
              // 带入请假类型 1事假  2病假
              this.form.type = this.businessType === '1' ? 1 : 2
            } else if (this.pageType == '2' && this.businessType) {
              // 带入加班类型 1节假日加班  2其他加班
              this.form.type = this.businessType === '1' ? 3 : ''
            } else {
              this.$set(this.form, 'type', '')
            }

            this.initList()
          } else {
            this.$message.error(res.message)
          }
        })
    },

    // 表格分页
    handleSizeChange(val) {
      this.listQuery.size = val
      this.initList()
    },
    // 点击序号
    handleCurrentChange(val) {
      this.listQuery.currentPage = val
      this.initList()
    },


    cancel() {
      this.$router.go(-1)
    },

    // 查询
    getTableList() {
      this.listQuery.currentPage = 1
      this.initList()
    },

    // 重置查询
    restList() {
      this.$refs['form'].resetFields()
      this.$set(this.form, 'type', '')
      // 清空时间级联选择数据
      this.time = []
      this.form.startDate = ''
      this.form.endDate = ''
      this.listQuery.currentPage = 1
      this.initList()
    },
  }
}
</script>

<style lang='scss' scoped>
/deep/ .el-dialog {
  background: #f6f7fa;
}
/deep/ .el-dialog__header {
  padding-bottom: 0;
}
</style>